export default {"src":"/_next/static/media/integrat.453a10ea.svg","height":20,"width":21};